import { render, staticRenderFns } from "./shopeePending.vue?vue&type=template&id=b9327b6c&"
import script from "./shopeePending.vue?vue&type=script&lang=js&"
export * from "./shopeePending.vue?vue&type=script&lang=js&"
import style0 from "./shopeePending.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports